
<div class="col-md-9 col-12 mb-30 card-container">
  <p class="title">{{ title }}</p>
    <div class="description">
      <ng-content></ng-content>
    </div>
</div> 
  